import { render } from "./YachtFormInputFields.vue?vue&type=template&id=8494c030"
import script from "./YachtFormInputFields.vue?vue&type=script&lang=ts"
export * from "./YachtFormInputFields.vue?vue&type=script&lang=ts"
script.render = render

export default script